'use client'
import Cookies from 'js-cookie'
import Image from 'next/image'
import { PrismicLink, PrismicRichText, PrismicText } from '@prismicio/react'

import type { HellobarProps } from '@/types/common'

const hellobarLinkProps = {
  tabIndex: 0,
  target: '_blank' as const,
  rel: 'noopener noreferrer' as const,
}

const Hellobar = ({ data, setShowHellobar }: HellobarProps) => {
  const hellobarHref = (data.link?.[0] as { text?: string } | undefined)?.text || '#'

  const desktopHellobarContent = (
    <>
      <PrismicRichText field={data.hellobar_text} />
      <span className="not-sr-only block text-base text-primary-green-150 after:absolute after:top-[68px] after:pl-0.5 after:transition-transform after:duration-300 after:ease-[cubic-bezier(0.645,0.045,0.355,1)] after:content-['→'] hover:after:translate-x-1 after:sm:top-[38px] md:ml-3 after:md:top-[12px]">
        <PrismicText field={data.button_text} />
      </span>
    </>
  )

  return (
    <div
      className="px-4 md:px-6"
      style={data.background_color ? { backgroundColor: data.background_color } : undefined}>
      <div className="relative [&_p]:text-white">
        {data.show_hellobar_text_on_mobile ? (
          <>
            <PrismicLink
              href={hellobarHref}
              {...hellobarLinkProps}
              className="flex w-full flex-row items-center justify-center gap-x-1.5 py-3 sm:hidden">
              <p className="text-center text-sm !text-white sm:text-base">{data.hellobar_text_on_mobile}</p>
              <Image src="/images/angle-right-green.svg" width={15} height={12} alt="" aria-hidden="true" />
            </PrismicLink>
            <PrismicLink
              href={hellobarHref}
              {...hellobarLinkProps}
              className="hidden w-full flex-col gap-y-1.5 py-3 sm:flex md:flex-row md:items-center md:justify-center md:gap-x-1.5">
              {desktopHellobarContent}
            </PrismicLink>
          </>
        ) : (
          <PrismicLink
            href={hellobarHref}
            {...hellobarLinkProps}
            className="flex w-full flex-col gap-y-1.5 py-3 md:flex-row md:items-center md:justify-center md:gap-x-1.5">
            {desktopHellobarContent}
          </PrismicLink>
        )}
        <button
          className="absolute -right-1.5 top-1 flex h-11 w-11 cursor-pointer items-center justify-center md:top-1 lg:right-5"
          onClick={() => {
            Cookies.set('hideHellobar', 'true')
            setShowHellobar(false)
          }}
          aria-label="Close announcement banner">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="#AFB0BC"
            className="h-5 w-5 md:h-6 md:w-6"
            role="none">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default Hellobar
